export const RPMComingSoonV3 = (function() {
	'use strict';

	// Site sits behind Pantheon full-page caching, so the random image is chosen
	// in the browser per page-load instead of being baked into the cached HTML.
	const RANDOMIZE_IN_JS = true;

	function init() {
		document.querySelectorAll('.rpmblock--coming-soon-v3').forEach(setup);
	}

	function setup(block) {
		const pic = block.querySelector('.rpmblock--coming-soon-v3__bg picture');
		const img = pic ? pic.querySelector('img') : null;
		const source = pic ? pic.querySelector('source') : null;

		if (RANDOMIZE_IN_JS && img) {
			const images = parseImages(block);
			if (images.length) {
				const pick = images[Math.floor(Math.random() * images.length)];
				if (source && pick.m) source.srcset = pick.m;
				if (pick.fp) block.style.setProperty('--cs-fp', pick.fp);
				if (pick.alt != null) img.alt = pick.alt;
				img.src = pick.d; // set last so the load event fires for the chosen image
			}
		}

		// Fade in once the chosen image is ready (bar follows via CSS delay).
		if (!img) {
			block.classList.add('is-loaded');
		} else if (img.complete && img.naturalWidth) {
			block.classList.add('is-loaded');
		} else {
			img.addEventListener('load', () => block.classList.add('is-loaded'));
			img.addEventListener('error', () => block.classList.add('is-loaded'));
		}
	}

	function parseImages(block) {
		try {
			return JSON.parse(block.dataset.images || '[]');
		} catch (e) {
			return [];
		}
	}

	return {
		init: init
	};
})();
